/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, DependencyList } from 'react';
import ReactTooltip from 'react-tooltip';

export const useDynamicTooltip = (dependencyList: DependencyList = []) => {
   useEffect(() => {
      ReactTooltip.rebuild();
   }, dependencyList);
};
